import styled from "@emotion/styled"
import Dialog from "@mui/material/Dialog"

export const StyledExpert = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 20px 22px 24px;
  border-radius: 24px;
  background: var(--cms-surface-primary);

  .heading-copy {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .page-title {
    margin: 0;
    font-size: 30px;
    font-weight: 800;
    color: var(--cms-text-primary);
    letter-spacing: -0.01em;
  }

  .page-subtitle {
    margin: 0;
    color: var(--cms-text-secondary);
    font-size: 13px;
    font-weight: 500;
  }

  .page-surface {
    border: 1px solid var(--cms-border);
    border-radius: 18px;
    background: var(--cms-surface-secondary);
    box-shadow: var(--cms-shadow);
    padding: 14px;
  }

  .new-expert-btn {
    text-transform: none;
    font-weight: 700;
    border-radius: 10px;
    min-height: 40px;
    padding: 8px 16px;
    box-shadow: 0 12px 24px rgba(37, 99, 235, 0.24);
  }

  .actions {
    display: flex;
    gap: 8px;
    align-items: center;
    flex-wrap: wrap;
  }

  .search-section {
    margin-bottom: 10px;
    padding: 14px;
    background: var(--cms-surface-muted);
    border-radius: 14px;
    border: 1px solid var(--cms-border);
    box-shadow: 0 10px 22px rgba(15, 23, 42, 0.06);
  }

  .search-form {
    display: grid;
    grid-template-columns: minmax(240px, 1fr) minmax(140px, 180px) auto;
    gap: 10px;
    align-items: end;
  }

  .clear-search-btn {
    text-transform: none;
    font-weight: 700;
    border-radius: 9px;
    min-height: 38px;
    padding: 6px 12px;
  }

  .table-container {
    background: var(--cms-surface-secondary);
    border-radius: 12px;
    border: 1px solid var(--cms-border);
    box-shadow: 0 12px 24px rgba(15, 23, 42, 0.06);
    overflow: hidden;
  }

  .MuiTableCell-head {
    background: var(--cms-table-head-bg);
    color: var(--cms-text-primary);
    font-weight: 700;
    font-size: 12px;
    border-bottom: 1px solid var(--cms-border);
  }

  .MuiTableCell-body {
    font-size: 13px;
    color: var(--cms-text-primary);
    border-bottom: 1px solid var(--cms-border);
    vertical-align: top;
  }

  .pagination-container {
    display: flex;
    justify-content: center;
    padding: 12px;
    background: var(--cms-surface-secondary);
    border-top: 1px solid var(--cms-border);
  }

  .status-badge {
    border-radius: 999px;
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
  }

  .status-active {
    background: #ecfdf3;
    color: #047857;
    border: 1px solid #bbf7d0;
  }

  .status-inactive {
    background: #fef2f2;
    color: #b91c1c;
    border: 1px solid #fecaca;
  }

  .action-buttons {
    display: flex;
    gap: 6px;
    flex-wrap: wrap;
  }

  .action-buttons .MuiIconButton-root {
    border: 1px solid var(--cms-border);
    border-radius: 8px;
    background: var(--cms-surface-secondary);
    &:hover {
      background: var(--cms-hover-bg);
    }
  }

  .description-cell {
    max-width: 340px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: pre-wrap;
    word-break: break-word;
  }

  .table-empty {
    text-align: center;
    color: var(--cms-text-secondary);
    font-weight: 600;
    padding: 18px;
  }

  @media (max-width: 860px) {
    .search-form {
      grid-template-columns: 1fr;
    }
  }
`

export const StyledExpertDialog = styled(Dialog)`
  .MuiPaper-root {
    width: min(980px, calc(100vw - 28px));
    border-radius: 20px;
    border: 1px solid var(--cms-border);
    background: var(--cms-dialog-bg);
    box-shadow: 0 28px 54px rgba(15, 23, 42, 0.2);
  }

  .MuiDialogTitle-root {
    padding: 20px 24px 8px;
  }

  .dialog-title-group {
    display: flex;
    flex-direction: column;
    gap: 5px;
  }

  .dialog-title {
    margin: 0;
    font-size: 22px;
    font-weight: 800;
    color: var(--cms-text-primary);
    letter-spacing: -0.01em;
  }

  .dialog-subtitle {
    margin: 0;
    font-size: 13px;
    color: var(--cms-text-secondary);
    font-weight: 500;
  }

  .MuiDialogContent-root {
    padding: 14px 24px 10px;
  }

  .section-label {
    margin: 0 0 8px;
    font-size: 14px;
    color: var(--cms-text-primary);
    font-weight: 800;
  }

  .selection-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  .MuiDialogActions-root {
    padding: 10px 24px 20px;
    gap: 10px;
  }

  .dialog-cancel-btn,
  .dialog-submit-btn {
    text-transform: none;
    border-radius: 10px;
    min-width: 108px;
    min-height: 40px;
    font-weight: 700;
  }

  .dialog-submit-btn {
    box-shadow: 0 12px 24px rgba(37, 99, 235, 0.24);
  }
`

